// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605051233/js/" + chunkId + "." + {"44":"b732acb0","225":"79c80ea9","481":"68f184c0","486":"90c8caf1","770":"035ba554"}[chunkId] + ".0.4058282324316298.chunk.js";
};